/**
 * Extract a user-facing message from API / mutation errors.
 */
export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  if (!error) return fallback;

  if (typeof error === 'string' && error.trim()) {
    return error;
  }

  if (error instanceof Error && error.message.trim()) {
    // Avoid nested "Failed to create config: Failed to create configuration"
    return error.message;
  }

  const axiosError = error as {
    response?: { data?: { error?: string; message?: string; details?: unknown } };
    message?: string;
  };

  const apiError = axiosError.response?.data?.error || axiosError.response?.data?.message;
  if (typeof apiError === 'string' && apiError.trim()) {
    return apiError;
  }

  if (typeof axiosError.message === 'string' && axiosError.message.trim()) {
    return axiosError.message;
  }

  return fallback;
};

export const formatCreateConfigError = (
  error: unknown,
  config: { platform?: string | null; report_type?: string | null }
): string => {
  const reason = getApiErrorMessage(error, 'Unable to save this configuration. Please try again.');
  const label = [config.platform, config.report_type].filter(Boolean).join(' · ');

  if (label) {
    return `Could not save ${label}: ${reason}`;
  }

  return reason;
};
